import Downloads from './DownloadsContainer';

export default Downloads;
